import { render } from "./InterviewPage.vue?vue&type=template&id=604c6168&scoped=true"
import script from "./InterviewPage.vue?vue&type=script&lang=js"
export * from "./InterviewPage.vue?vue&type=script&lang=js"

import "./InterviewPage.vue?vue&type=style&index=0&id=604c6168&scoped=true&lang=css"

import exportComponent from "D:\\project2025\\green-lit-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604c6168"]])

export default __exports__